// v10/src/components/admin/inventory/categoryIcons.js
//
// Helper que mapea categoría de inventario (A8) → ícono lucide-react.
// Las categorías deben matchear los enums del backend
// (inventoryItemsController.VALID_CATEGORIES).

import {
  Droplet, Filter, Zap, Circle, Battery, Disc,
  Wrench, Briefcase, Plug, Package, Box,
} from 'lucide-react';

const CATEGORY_ICONS = {
  oil:        Droplet,
  oil_filter: Filter,
  spark_plug: Zap,
  tire:       Circle,
  battery:    Battery,
  brake_pad:  Disc,
  hardware:   Wrench,
  tool:       Briefcase,
  electrical: Plug,
  consumable: Package,
  other:      Box,
};

export const getCategoryIcon = (category) => CATEGORY_ICONS[category] || Box;

// Lista canónica de categorías (orden estable para selectores y agrupaciones).
export const CATEGORY_KEYS = [
  'oil', 'oil_filter', 'spark_plug', 'tire', 'battery', 'brake_pad',
  'hardware', 'tool', 'electrical', 'consumable', 'other',
];

export default getCategoryIcon;
